import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import './SettingsMenuWrapper.scss';
import {regular} from '@fortawesome/fontawesome-svg-core/import.macro';

export type SettingsMenuWrapperProps = {
  children?: React.ReactNode;
  hidden: boolean;
  onBack: () => void;
};

export const SettingsMenuWrapper = ({ children, hidden, onBack }: SettingsMenuWrapperProps) => {
  return (
    <div className={classNames('settings-menu-wrapper', hidden && 'settings-menu-wrapper--hidden')}>
      <div className="settings-menu-wrapper__header">
        <div className="settings-menu-wrapper__header-back" onClick={onBack}>
          <FontAwesomeIcon
            icon={regular('chevron-left')}
            size="lg"
            fixedWidth
            className="settings-menu-wrapper__header-back__icon"
          />
          BACK
        </div>
      </div>
      {children}
    </div>
  );
};
